import axios from "./interceptor";

// Base URL for Verified Leads API
const baseURL = `${process.env.REACT_APP_BASE_URL}/verified-leads`;

// CREATE
export const createLead = async (data) => {
  return await axios.post(`${baseURL}/`, data);
};

// READ ALL
export const getAllLeads = async () => {
  return await axios.get(`${baseURL}/`);
};

export const getQuotationsByEmail = async (id) => {
  return await axios.get(`${baseURL}/${id}/quotations`);
};

// READ ONE
export const getLeadById = async (id) => {
  return await axios.get(`${baseURL}/${id}`);
};

// UPDATE
export const updateLead = async (id, data) => {
  return await axios.put(`${baseURL}/${id}`, data);
};

// Verify Inquiry and create Lead
export const verifyInquiryLead = async (id) => {
  try {
    const response = await axios.post(`${baseURL}/verify-inquiry/${id}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// DELETE
export const deleteLead = async (id) => {
  return await axios.delete(`${baseURL}/${id}`);
};
